import React, { useEffect, useState } from "react";
import infoImg from "../../assets/images/info.svg";
import cross from "../../assets/images/cross.svg";
import uploadIcon from "../../assets/images/upload-icon.svg";
import {useNavigate } from "react-router-dom";
import "./upload-video.scss";
import { getPreSignedUrl, uploadGameFile, getGameFile,  uploadFileToServer} from "../../services/gameFile";
import axios from "axios";


function UploadVideo() {
  const [key, setFileName] = useState("");
  const [size, setFileSize] = useState(0);
  const token = localStorage.getItem('token');
  // const [mimetype, setFileType] = useState('');
  const [username, setUsername] = useState('')
  const navigate = useNavigate();
  const usernamepull = localStorage.getItem('username');
  const [uploadProgress, setUploadProgress] = useState(0);
  let combinedName;
  let vidName;
  let originalFile;

  useEffect(() => {
    const storedName = localStorage.getItem('name');
    
    if (storedName) {
      setUsername(storedName);
    }
  }, []);
  const [mimetype, setFileType] = useState("");

  const fileSelect = (e) => {
    console.log("target file is", e.target.files[0]);
    originalFile=e.target.files[0];
    
    fileValues(e.target.files[0]);
  };


  console.log('JWT token 1:', token);
  // console.log('Decoded Token:', this.jwtService.decode(token));

  function extractTimestamp(filename) {
    // Updated regular expression to include milliseconds
    const match = filename.match(/Desktop (\d{2})-(\d{2})-(\d{4})_(\d{1,2})-(\d{2})-(\d{2})-(\d{3})/);
  
    if (match) {
      // Include milliseconds in the destructuring
      const [, month, day, year, hour, minute, second, millisecond] = match;
      const date = new Date(year, month - 1, day, hour, minute, second, millisecond);
      const roundedSeconds = Math.round(date.getSeconds() / 10) * 10;
      date.setSeconds(roundedSeconds);
  
      const unixTimestamp = Math.floor(date.getTime() / 60000);
      return unixTimestamp;
    }
  
    return "";
  }

  function fileValues(files) {
    setFileName(files.name);
    setFileSize(files.size);
    setFileType(files.type);
    const partSize = 5 * 1024 * 1024; // 5 MB, or choose your desired part size
    // const numParts = determineNumParts(files.size, partSize);
    
    const unixTimestamp = extractTimestamp(files.name);
    combinedName = `${usernamepull}-${unixTimestamp}`;
    getResponsePreSignedUrl();

    // Call the uploadFile function to start the multipart upload
    // uploadFile(originalFile);

  }

  const fileFilters = {
    key,
    size,
    mimetype,
  };



  async function getResponsePreSignedUrl() {
    try {
      await getPreSignedUrl(originalFile).then((res) => {
        console.log("filefilter is", fileFilters)
        const url = res;
        if (url) {
          const fileData = {
            fileUrl: url,
            fileExt: "video/mp4",
            fileMeta: "meta",
          };
          getResponseuploadGameFile(fileData);
        }
      });
    } catch (error) {}
  }

  async function getResponseuploadGameFile(fileData) {
    console.log("just cheacking", originalFile.name)
    vidName = originalFile.name;
    try {
      // const navigate = useNavigate();
      await uploadGameFile(fileData).then((res) => {
        console.log("URL:",fileData.fileUrl);
      
         // Upload the file to the pre-signed URL using Axios
      axios
      .put(fileData.fileUrl, originalFile, {
        headers: {
          'Content-Type': fileData.fileExt,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
          console.log('Upload progress:', percentCompleted + '%');
        },
      })
      .then(() => {
        console.log('File uploaded successfully');
        navigate('/timeline-screen', { state: { combinedName, vidName } });
      })
      .catch(error => {
        console.error('Error uploading the file', error);
      });
        if(res?.fileUrl){
        }
      });
      
      // navigate('/timeline-screen', { state: { combinedName } });
    } catch (error) {}
  }

  useEffect(() => {}, []);
  return (
    <div className="video-upload vh-100">
      <div className="bgBlue h-100 p-4">
        <div className="justify-between">
          <img src={infoImg} alt="info" />
          <button className="actionBtn red" onClick={() => navigate('/dashboard')}>
            <img src={cross} alt="info" />
          </button>
        </div>
        <div className="upload-sec px-5 mt-5">
          <div className="font-40 white pt-4">Hello {username}</div>
          <div className="font-22 white mt-1">
            Upload your first game play to see your timeline
          </div>
          {uploadProgress > 0 && (
            <div className="uploading-progress">
              <div className="uploading-text">Uploading...</div>
              <progress id="uploadProgress" value={uploadProgress} max="100"></progress>
            </div>
          )}
          <label for="myfile" className="vdo-upload center mt-4">
            <div className="uploadFileDiv text-center">
              <img src={uploadIcon} alt="uploadIcon" />
              <div className="white poppins font-24">Upload gameplay</div>
            </div>
            <input
              className="d-none"
              onChange={(event) => {
                fileSelect(event);
              }}
              type="file"
              id="myfile"
              name="myfile"
            />
          </label>
        </div>
      </div>
    </div>
  );
}
export default UploadVideo;
